<template>
  <form class="form">
    <label class="visually-hidden" for="newItem">Add {{ itemType }}</label>
    <div class="input-group">
      <input
        v-model="newItem"
        type="text"
        class="form-control mb-2 mb-sm-0 text-xl flex-fill border-square-right"
        :placeholder="`Enter New ${itemType}`"
        :aria-label="`Enter New ${itemType}`"
        aria-describedby="basic-addon2"
      />
      <div class="input-group-append">
        <button
          class="btn btn-primary text-xl border-square-left"
          type="button"
          @click="addItem"
        >
          Add {{ itemType }}
        </button>
      </div>
    </div>
  </form>
</template>

<script lang="js">
import { defineComponent, onMounted, ref } from "@vue/composition-api";

export default defineComponent({
  setup() {
    const newItem = ref("");

    function addItem() {
      if (newItem.value) {
        this.$emit("add-item", { name: newItem.value });
        newItem.value = "";
      }
    }

    return {
      newItem,
      addItem
    };
  },
  props: {
    itemType: String
  }
});
</script>
